import cn from 'classnames';
import type { ComponentProps } from 'react';

import './backdrop.scss';

type BackdropProps = ComponentProps<'div'>;

export function Backdrop({ className, ...props }: BackdropProps) {
    return <div aria-hidden="true" {...props} className={cn('backdrop', className)} />;
}
